import { render, staticRenderFns } from "./FormIssueContent.vue?vue&type=template&id=45c3cfac&"
import script from "./FormIssueContent.vue?vue&type=script&lang=js&"
export * from "./FormIssueContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports